import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from './../../providers/utils.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  @Input() canDeleteIntervener = false;
  @Input() elementsList: [];
  @Input() toggle = true;
  @Input() show = true;
  @Input() tittle = 'default';
  @Input() arrow = false;
  @Input() subtitle: string;
  @Input() pendencies: number;
  @Input() formGroup: any;
  @Input() class = 'text-primary';

  @Output() statusChange = new EventEmitter();
  @Output() idsToDelete = new EventEmitter();

  constructor(private translate: TranslateService, private utils: UtilsService) {}

  ngOnInit(): void {}

  statusHasChange(): void {
    this.show = !this.show;
    this.statusChange.emit(this.show);
  }

  async openModal(event: any) {
    const title = this.translate.instant('COMPONENTS.MODALS.DELETE_INTERVENER');

    const message = `${this.translate.instant(
      'COMPONENTS.MODALS.ASK_DELETE_INTERVENER'
    )} <strong>${this.translate.instant('COMPONENTS.MODALS.INTERVENER')}</strong>?`;

    this.utils.showAlert(title, message, () => {
      this.handleDelete(this.formGroup);
    });
  }

  handleDelete = async (values: any) => {
    const ids: number[] = [];

    // Verificar se o id do interveniente não é nulo
    if (values.value.id !== null && values.value.id !== undefined) {
      ids.push(values.value.id);
    }

    // Verificar se o id do conjuge não é nulo
    if (values.value.idPartner !== null && values.value.idPartner !== undefined) {
      ids.push(values.value.idPartner);
    }

    this.idsToDelete.emit(ids);
  };
}
